import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
};

const IconWallet: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#3E454D',
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15 3.5415H5C2.985 3.5415 1.875 4.6515 1.875 6.6665V13.3332C1.875 15.3482 2.985 16.4582 5 16.4582H15C17.015 16.4582 18.125 15.3482 18.125 13.3332V6.6665C18.125 4.6515 17.015 3.5415 15 3.5415ZM16.875 13.3332C16.875 14.6473 16.3142 15.2082 15 15.2082H5C3.68583 15.2082 3.125 14.6473 3.125 13.3332V8.95817H16.875V13.3332ZM16.875 7.70817H3.125V6.6665C3.125 5.35234 3.68583 4.7915 5 4.7915H15C16.3142 4.7915 16.875 5.35234 16.875 6.6665V7.70817ZM5.20833 12.4998C5.20833 12.1548 5.48833 11.8748 5.83333 11.8748H8.33333C8.67833 11.8748 8.95833 12.1548 8.95833 12.4998C8.95833 12.8448 8.67833 13.1248 8.33333 13.1248H5.83333C5.48833 13.1248 5.20833 12.8448 5.20833 12.4998Z"
      fill={color}
    />
  </svg>
);

export default IconWallet;
